import { render, staticRenderFns } from "./WafRuleCreate.vue?vue&type=template&id=f40d2b5c"
import script from "./WafRuleCreate.vue?vue&type=script&lang=js"
export * from "./WafRuleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports